import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonLdService, MetaService } from '@app/core';
import { PARTNERS_OPENFORGE_FAQS } from '../../constants';
import {
  PartnersOpenforgeBenefitsSectionComponent,
  PartnersOpenforgeCtaSectionComponent,
  PartnersOpenforgeFaqSectionComponent,
  PartnersOpenforgeHeroSectionComponent,
  PartnersOpenforgeServicesSectionComponent,
} from '../index';

@Component({
  selector: 'app-partners-openforge',
  imports: [
    PartnersOpenforgeHeroSectionComponent,
    PartnersOpenforgeBenefitsSectionComponent,
    PartnersOpenforgeServicesSectionComponent,
    PartnersOpenforgeFaqSectionComponent,
    PartnersOpenforgeCtaSectionComponent,
  ],
  templateUrl: './partners-openforge.component.html',
  styleUrl: './partners-openforge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersOpenforgeComponent {
  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setDescription(
      'Partner with OpenForge for expert Capacitor app development and Capawesome Cloud integration. Trusted enterprise-grade mobile app development services.',
    );
    this.metaService.setTitle(
      'OpenForge Partnership - Trusted Capacitor Development',
    );
    this.metaService.setKeywords([
      'OpenForge',
      'Capacitor development',
      'app development services',
    ]);
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'OpenForge Partnership - Capawesome Cloud',
        'Expert Capacitor app development and Capawesome Cloud integration.',
        'https://cloud.capawesome.io/partners/openforge/',
      ),
      JsonLdService.buildFaqSchema(PARTNERS_OPENFORGE_FAQS),
    ]);
  }
}
